var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.9667C9.09171 18.9667 8.19171 18.7 7.48337 18.175L3.90004 15.5C2.95004 14.7917 2.20837 13.3083 2.20837 12.1333V5.93333C2.20837 4.65 3.15004 3.28333 4.35837 2.83333L8.51671 1.275C9.34171 0.966666 10.6417 0.966666 11.4667 1.275L15.625 2.83333C16.8334 3.28333 17.775 4.65 17.775 5.93333V12.125C17.775 13.3083 17.0334 14.7833 16.0834 15.4917L12.5 18.1667C11.8084 18.7 10.9084 18.9667 10 18.9667ZM8.95837 2.45L4.80004 4.00833C4.09171 4.275 3.46671 5.175 3.46671 5.94167V12.1333C3.46671 12.925 4.02504 14.0333 4.65004 14.5L8.23337 17.175C9.19171 17.8917 10.8084 17.8917 11.775 17.175L15.3584 14.5C15.9917 14.025 16.5417 12.925 16.5417 12.1333V5.93333C16.5417 5.175 15.9167 4.275 15.2084 4L11.05 2.44167C10.4834 2.24167 9.51671 2.24167 8.95837 2.45Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88334 11.8583C8.72501 11.8583 8.56668 11.8 8.44168 11.675L7.10001 10.3333C6.85835 10.0917 6.85835 9.69167 7.10001 9.45C7.34168 9.20833 7.74168 9.20833 7.98335 9.45L8.88334 10.35L12.025 7.20833C12.2667 6.96667 12.6667 6.96667 12.9083 7.20833C13.15 7.45 13.15 7.85 12.9083 8.09167L9.32501 11.675C9.20001 11.8 9.04168 11.8583 8.88334 11.8583Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.92848c9fc40cb6e34c2c8a7a6e9a7707.svg";
export { ForwardRef as ReactComponent };